"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const localized_strings_1 = __importDefault(require("localized-strings"));
const utils_1 = require("../TableRow/utils");
const locales = new localized_strings_1.default({
    en: {
        [utils_1.ColumnName.Details]: 'Details',
        [utils_1.ColumnName.TotalWithoutTaxes]: 'Total excl. VAT',
        [utils_1.ColumnName.UnitPrice]: 'Unit price',
        [utils_1.ColumnName.Units]: 'Qty',
        [utils_1.ColumnName.VatPercentage]: 'VAT %',
    },
    fr: {
        [utils_1.ColumnName.Details]: 'Détails',
        [utils_1.ColumnName.TotalWithoutTaxes]: 'Total HT',
        [utils_1.ColumnName.UnitPrice]: 'Prix unitaire',
        [utils_1.ColumnName.Units]: 'Qté',
        [utils_1.ColumnName.VatPercentage]: 'TVA %',
    },
});
exports.default = locales;
